// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor_vqo1U {
  height: 100%;
}

.editor_vqo1U [contenteditable="true"] {
  height: 100%;
  padding : var( --size-padMedium ) var( --size-padLarge );
}

.editor_vqo1U p:first-child, .editor_vqo1U h1:first-child, .editor_vqo1U h2:first-child, .editor_vqo1U h3:first-child {
  margin-top: 0;
}

.editor_vqo1U p:last-child, .editor_vqo1U h1:last-child, .editor_vqo1U h2:last-child, .editor_vqo1U h3:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/detail/customText/textEditor/CustomTextEditor.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".editor {\n  height: 100%;\n}\n\n.editor [contenteditable=\"true\"] {\n  height: 100%;\n  padding : var( --size-padMedium ) var( --size-padLarge );\n}\n\n.editor p:first-child, .editor h1:first-child, .editor h2:first-child, .editor h3:first-child {\n  margin-top: 0;\n}\n\n.editor p:last-child, .editor h1:last-child, .editor h2:last-child, .editor h3:last-child {\n  margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `editor_vqo1U`
};
export default ___CSS_LOADER_EXPORT___;
